import {gql} from '@apollo/client';

/**
 * Fetches a paginated list of palowans with the count of vacation assignment ranges per palowan.
 * Used by the grouped "Por Palowan" table introduced in US-02.07.
 *
 * @param countryCode - ISO 3166-1 alpha-3 country code to scope the query (e.g., 'MEX', 'COL').
 * @param search - Optional partial name filter.
 * @param page - 1-based page number.
 * @param pageSize - Number of results per page.
 */
export const GET_PALOWANS_WITH_VACATION_ASSIGNMENT_COUNT = gql`
  query GetPalowansWithVacationAssignmentCount(
    $countryCode: String!
    $search: String
    $page: Int
    $pageSize: Int
  ) {
    getPalowansWithVacationAssignmentCount(
      countryCode: $countryCode
      search: $search
      page: $page
      pageSize: $pageSize
    ) {
      edges {
        node {
          palowanId
          firstName
          lastName
          email
          totalRangeCount
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`;

/**
 * Fetches paginated, alphabetically sorted palowan vacation assignments for a given country.
 * Supports optional filtering by exact palowan UUID (preferred when a user was selected from
 * the autocomplete) or by partial name search, plus pagination.
 */
export const GET_PALOWAN_VACATION_ASSIGNMENTS = gql`
  query GetPalowanVacationAssignments(
    $countryCode: String
    $palowanId: String
    $search: String
    $page: Int
    $pageSize: Int
  ) {
    getPalowanVacationAssignments(
      countryCode: $countryCode
      palowanId: $palowanId
      search: $search
      page: $page
      pageSize: $pageSize
    ) {
      edges {
        node {
          id
          palowan {
            id
            firstName
            lastName
            email
            country
          }
          seniorityFromYears
          seniorityToYears
          vacationDays
          effectiveVacationDays
          isActive
          createdAt
          updatedAt
        }
      }
      pageInfo {
        page
        pageSize
        totalCount
        hasNextPage
      }
      totalCount
    }
  }
`;
